import React, { useEffect, createElement } from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
declare global {
  interface Window {
    Tally?: {
      loadEmbeds: () => void;
      openPopup: (formId: string, options?: Record<string, any>) => void;
      closePopup: (formId: string) => void;
    };
  }
}
const TALLY_FORM_ID = '2E4rjD';
export function HeroSection() {
  useEffect(() => {
    const TALLY_SRC = 'https://tally.so/widgets/embed.js';
    if (window.Tally) return;
    if (document.querySelector(`script[src="${TALLY_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = TALLY_SRC;
    script.async = true;
    document.head.appendChild(script);
  }, []);
  const openRegisterPopup = () => {
    const open = () => {
      if (window.Tally) {
        window.Tally.openPopup(TALLY_FORM_ID, {
          layout: 'modal',
          width: 700,
          autoClose: 5000
        });
      } else {
        window.open(`https://tally.so/r/${TALLY_FORM_ID}`, '_blank');
      }
    };
    if (window.Tally) {
      open();
    } else {
      setTimeout(open, 500);
    }
  };
  return <section className="w-full bg-white" data-id="element-296" data-mp="2bfhzufm0v8m5">
      <div className="max-w-7xl mx-auto px-5 md:px-12 pt-8 pb-10 md:pt-16 md:pb-20" data-id="element-297" data-mp="2p5bp2z1fvuwe">
        <div className="flex flex-col items-center text-center max-w-2xl mx-auto" data-id="element-298" data-mp="2p76b6gog5t22">
          <h1 className="mb-4 md:mb-5 text-[2rem] md:text-[3.25rem] font-semibold text-[#111111] leading-[1.15] tracking-tight" data-id="element-299" data-mp="2kcii04ii0ah5">
            <div className="text-[40px]" data-id="element-300" data-mp="2u4ojq5yjy69j">
              Most families know they should do more to stay safe online.
            </div>
            <div className="text-[#631bb7] text-[40px]" data-id="element-301" data-mp="3834qfwwezwro">
              Caveo makes sure they actually do it.
            </div>
          </h1>

          <p className="md:text-lg text-gray-500 mb-6 md:mb-8 max-w-xl mx-auto text-[16px] font-[400]" data-id="element-302" data-mp="3339z5s8q9563">
            Knowing isn't enough. Caveo guides every member of your family
            through the actions that matter and keeps them on track so nothing
            slips.
          </p>

          <div className="flex flex-row items-center gap-4 mb-6 md:mb-8" data-id="element-303" data-mp="38vfnl000ei0x">
            <Link to="/onboarding" className="bg-[#1a0647] text-white px-7 py-3.5 rounded-md font-medium text-sm no-underline hover:bg-[#2a0a6e] transition-colors" data-id="element-304" data-mp="3dt7gnxce4a6p">
              Get Started
            </Link>
            <a href="#how-it-works" className="text-[#111111] font-medium text-sm no-underline hover:text-gray-600 transition-colors flex items-center gap-1.5 py-3.5" data-id="element-305" data-mp="3rsgsylxh6k5e">
              <span data-id="element-306" data-mp="5c2tnax8bcuu">See How Caveo Works</span>
              <ChevronRightIcon size={16} data-id="element-307" data-mp="5d4eg741rdpr" />
            </a>
          </div>

          {/* Social proof avatars */}
          <div className="flex items-center gap-2.5 flex-wrap justify-center" data-id="element-308" data-mp="ads4oqkgbqix">
            <div className="flex -space-x-2" data-id="element-309" data-mp="eevnnlxsq2od">
              <img src="https://cdn.magicpatterns.com/uploads/6giMtsG68yxp89aaHTtkX6/Screenshot_2026-02-22_at_12.56.48_AM.png" alt="Member" className="w-7 h-7 rounded-full object-cover border-2 border-white" data-id="element-310" data-mp="jc45flf184p3" />
              <img src="https://cdn.magicpatterns.com/uploads/iaPLUAtSe7j7WSJaQUSv1g/Screenshot_2026-02-22_at_12.56.42_AM.png" alt="Member" className="w-7 h-7 rounded-full object-cover border-2 border-white" data-id="element-311" data-mp="1yxfwf10fbxv8" />
              <img src="https://cdn.magicpatterns.com/uploads/hCu7TZEUwwQyaw75WuLKPE/Screenshot_2026-02-22_at_12.56.35_AM.png" alt="Member" className="w-7 h-7 rounded-full object-cover border-2 border-white" data-id="element-312" data-mp="2mjmfqjfat00r" />
              <img src="https://cdn.magicpatterns.com/uploads/wJ71gACjNWRRTKd8byxEK6/Screenshot_2026-02-22_at_12.51.11_AM.png" alt="Member" className="w-7 h-7 rounded-full object-cover border-2 border-white" data-id="element-313" data-mp="28uatrgkyns7x" />
              <img src="https://cdn.magicpatterns.com/uploads/f2JgivSXHBCeH7uM5GKP7x/Screenshot_2026-02-22_at_12.55.40_AM.png" alt="Member" className="w-7 h-7 rounded-full object-cover border-2 border-white" data-id="element-314" data-mp="2l2nqt108acf9" />
            </div>
            <p className="text-xs text-gray-500 font-medium" data-id="element-315" data-mp="2c4c2x6qqxsqi">
              Helping families actually get protected — not just informed
            </p>
          </div>
        </div>

        {/* Logo strip */}
        <div className="pt-16 md:pt-24 pb-4" data-id="element-316" data-mp="38s8jwcq3iq29">
          <p className="text-center text-sm text-gray-500 mb-8 font-medium" data-id="element-317" data-mp="38qyk9j3lh9ti">
            Trusted by families who take digital safety seriously
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10" data-id="element-318" data-mp="2zzoij4if67dq">
            <img src="https://cdn.magicpatterns.com/uploads/ut1pKKvicHWLWvo6NRe2GY/transparent-wsj-logo-png-the-wall-street-journal-c-8c851bcb8d9e4624.jpg" alt="Wall Street Journal" className="h-4 md:h-5 opacity-40 grayscale" data-id="element-319" data-mp="2zxllw1mrhg01" />
            <img src="https://cdn.magicpatterns.com/uploads/oZnCNixd9RzyC1qjqpbC9m/The_New_York_Times_logo.png" alt="The New York Times" className="h-3 md:h-4 opacity-40 grayscale" data-id="element-320" data-mp="5nka2jgym2tx" />
            <img src="https://cdn.magicpatterns.com/uploads/xty7mcBNjyknELbhKf8VgC/forbes.png" alt="Forbes" className="h-4 md:h-5 opacity-40 grayscale" data-id="element-321" data-mp="afv8tizyrikw" />
            <img src="https://cdn.magicpatterns.com/uploads/54LBYQ2axiem9cZcDJAjjG/Bloomberg_Logo.png" alt="Bloomberg" className="h-3 md:h-4 opacity-40 grayscale" data-id="element-322" data-mp="3ev3iz9nx78ql" />
            <img src="https://cdn.magicpatterns.com/uploads/2aPSjLGvnBG7VdpaAjHKcr/wired-logo-transparent.png" alt="Wired" className="h-3 md:h-4 opacity-40 grayscale" data-id="element-323" data-mp="3nu8gqdrnqy1p" />
            <img src="https://cdn.magicpatterns.com/uploads/wG62U3uK5ijYVDcfEJtPYN/cnbc.png" alt="CNBC" className="h-3 md:h-4 opacity-40 grayscale" data-id="element-324" data-mp="134srhn837he6" />
          </div>
        </div>

        {/* Register CTA */}
        <div className="flex justify-center pt-10 md:pt-12" data-id="element-325" data-mp="1k65besh551qv">
          <button type="button" onClick={openRegisterPopup} className="bg-[#1a0647] text-white px-8 py-3.5 rounded-md font-medium text-sm hover:bg-[#2a0a6e] transition-colors" data-id="element-326" data-mp="1k4lq2ngmo0i8">
            Register
          </button>
        </div>
      </div>
    </section>;
}